<div class="add-class">
    <div class="table-operations">
        <button nz-button nzType="primary" [nzSize]="'large'"
                [queryParams]="{ page: returnPage }"
                [routerLink]="'/admin/classes/'+classId+'/students/index'">
            <i nz-icon nzType="left" nzTheme="outline"></i>返回列表</button>

        <button nz-button nzType="primary" [nzSize]="'large'" [routerLink]="'/admin/classes/'+classId+'/students/add/batch_add'">
            <i nz-icon nzType="team" nzTheme="outline"></i>批量添加学生
        </button>
    </div>
    <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm($event,validateForm.value)">
        <nz-form-item>
            <nz-form-label [nzSpan]="7" nzRequired>学生姓名</nz-form-label>
            <nz-form-control [nzSpan]="12" nzHasFeedback nzErrorTip="请正确输入学生姓名！">
                <input nz-input formControlName="name" placeholder="学生姓名">
                <!--<div nzErrorTip *ngIf="validateForm.get('name').dirty && validateForm.get('name').errors  ">-->
                    <!--<ng-container *ngIf="validateForm.get('name').hasError('required')">-->
                        <!--请正确输入学生姓名！-->
                    <!--</ng-container>-->
                <!--</div>-->
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-label [nzSpan]="7" >学生性别</nz-form-label>
            <nz-form-control [nzSpan]="12" nzHasFeedback  class="sex">
                <nz-radio-group nzName="sex" formControlName="sex">
                    <label nz-radio nzValue="1" >男</label>
                    <label nz-radio nzValue="0" >女</label>
                </nz-radio-group>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-label [nzSpan]="7" >生日</nz-form-label>
            <nz-form-control [nzSpan]="12" >
                <nz-date-picker formControlName="birthday"></nz-date-picker>
            </nz-form-control>

        </nz-form-item>
        <nz-form-item>
            <nz-form-label [nzSpan]="7" nzRequired>学生电话</nz-form-label>
            <nz-form-control [nzSpan]="12" nzHasFeedback [nzErrorTip]="phoneErrorTpl">
                <input nz-input
                        style="width: 100%"
                        nz-input
                        formControlName="phone"
                        placeholder="学生电话">
                    <ng-template #phoneErrorTpl let-control>
                        <ng-container *ngIf="validateForm.get('phone')?.hasError('dup_students')">
                            <div [innerHTML]="validateForm.get('phone')?.getError('message')"></div>
                        </ng-container>
                        <ng-container *ngIf="validateForm.get('phone')?.hasError('dup_phone')">
                            不能使用该手机号！
                        </ng-container>
                        <ng-container *ngIf="validateForm.get('phone')?.hasError('required')">
                            请正确输入学生电话！
                        </ng-container>
                    </ng-template>

            </nz-form-control>
        </nz-form-item>
        <div nz-row *ngIf="mergePhoneConfirm">
            <div nz-col [nzSpan]="7" style="text-align: right;">确认添加: </div>
            <br>
            <div nz-col [nzSpan]="12">
                <nz-switch (click)="sureMergeFn($event)"></nz-switch>
            </div>
        </div>

        <nz-form-item *ngIf="!editUserId">
            <nz-form-label [nzSpan]="7">补充作业</nz-form-label>
            <nz-form-control [nzSpan]="12">
                <label nz-checkbox formControlName="sync_homework" (ngModelChange)="onSyncHomeworkChange($event)">
                    从班级未过期作业中选择要补充给该学生的作业
                </label>
                <div class="form-help">勾选后会查询当前班级未结束的作业，包含未开始作业。</div>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item *ngIf="!editUserId && validateForm.value.sync_homework">
            <nz-form-label [nzSpan]="7">选择作业</nz-form-label>
            <nz-form-control [nzSpan]="15">
                <nz-table
                        nzSize="small"
                        [nzData]="activeHomeworks"
                        [nzLoading]="isLoadingHomeworks"
                        [nzFrontPagination]="false">
                    <thead>
                    <tr>
                        <th>选择</th>
                        <th>作业名称</th>
                        <th>开始时间</th>
                        <th>资源数量</th>
                        <th>发送学生数</th>
                        <th>创建时间</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let homework of activeHomeworks">
                        <td>
                            <label
                                    nz-checkbox
                                    [ngModelOptions]="{ standalone: true }"
                                    [ngModel]="selectedHomeworkIds.includes(homework.id)"
                                    (ngModelChange)="toggleHomework(homework.id, $event)">
                            </label>
                        </td>
                        <td>{{ homework.name }}</td>
                        <td>{{ homework.start }}</td>
                        <td>
                            <a
                                    *ngIf="homework.resource_summary?.total_count; else emptyResourceTpl"
                                    nz-popover
                                    nzPopoverTrigger="click"
                                    nzPopoverTitle="资源列表"
                                    [nzPopoverContent]="resourceTpl">
                                {{ homework.resource_summary.total_count }}
                            </a>
                            <ng-template #emptyResourceTpl>0</ng-template>
                            <ng-template #resourceTpl>
                                <div class="homework-resource-list">
                                    <div *ngFor="let group of homework.resource_summary.types" class="homework-resource-group">
                                        <div class="homework-resource-title">{{ group.label }}（{{ group.count }}）</div>
                                        <div *ngFor="let name of group.names" class="homework-resource-name">{{ name }}</div>
                                    </div>
                                </div>
                            </ng-template>
                        </td>
                        <td>{{ homework.students_count }}</td>
                        <td>{{ homework.createon }}</td>
                    </tr>
                    </tbody>
                </nz-table>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-control [nzOffset]="7" [nzSpan]="12">
                <button style="margin-right:1rem;" nz-button nzType="primary" [disabled]="!validateForm.valid || isSubmitting">提交</button>
                <button nz-button (click)="resetForm($event)">清空</button>
            </nz-form-control>
        </nz-form-item>
    </form>
</div>
